<template>
  <div>
    <div class="d-flex align-center">
      <h2 v-if="child">
        {{ child.lastName }} {{ child.firstName }} - Parent Information
      </h2>
      <v-spacer></v-spacer>
    </div>

    <div>
      <v-progress-linear
        v-if="isSaving || loading"
        indeterminate
        color="primary"
        class="my-8"
      ></v-progress-linear>
    </div>

    <v-divider class="my-4"></v-divider>
    <div class="d-flex align-center">
      <h3 class="primary--text">Parent Information</h3>
      <v-spacer></v-spacer>
      <v-btn
        x-large
        variant="flat"
        color="primary"
        @click="save"
        :disabled="isSaving"
        >{{ $t('common.save') }}</v-btn
      >
    </div>

    <div class="my-4" v-for="p in parentInfo" :key="p.parent.key">
      <h2>{{ p.parent.lastName }} {{ p.parent.firstName }}</h2>
      <child-info-page
        :elements="p.parentInfo"
        @input="updateInfo($event, p)"
      ></child-info-page>
      <v-divider class="my-4"></v-divider>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { ParentInfo } from "@/api/ApiParent";
import { parentDocumentModule } from "@/store/dataModules/parentDocumentModule";
import { ParentInfoData, ParentResponse } from "chaild-api/lib";

import ChildInfoPage from "@/components/organisms/ChildInfoPage.vue";

interface DataType {
  isSaving: boolean;
  loading: boolean;
}

export default defineComponent({
  components: {
    ChildInfoPage,
  },

  computed: {
    doc() {
      return parentDocumentModule.doc;
    },
    parentInfo(): ParentInfo[] {
      if (this.doc) {
        return this.doc;
      }
      return [];
    },
    child() {
      return parentDocumentModule.child;
    },
  },

  data: (): DataType => {
    return {
      isSaving: false,
      loading: false,
    };
  },

  methods: {
    updateInfo(value: ParentInfoData, p: ParentInfo) {
      parentDocumentModule.updateInfoValue({
        parentId: p.parent.parentId,
        value: value,
      });
      parentDocumentModule.updateDataToUpdate({
        parentId: p.parent.parentId,
        value: value,
      });
    },
    async save() {
      this.isSaving = true;
      await parentDocumentModule.saveUpdates();
      this.isSaving = false;
    },
  },

  async mounted() {
    this.loading = true;
    const childId = this.$route.params.childId as string;
    if (childId) {
      try {
        const parsed = parseInt(childId);
        parentDocumentModule.clearLocalData();
        parentDocumentModule.setChildId(parsed);
        await parentDocumentModule.getParentInfo();
        await parentDocumentModule.getChild();
      } catch {
        return;
      }
    }

    this.loading = false;
  },
});
</script>
